import React from 'react';
import styled, { keyframes } from 'styled-components';
import loaderImage from '../../../app/components/svgIcons/loaderImage.png'; // Adjust path if needed

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: ${({ width }) => (width ? width : '60px')};
  height: ${({ height }) => (height ? height : '60px')};
  background-image: url(${loaderImage});
  background-size: contain;
  background-repeat: no-repeat;
  animation: ${spin} 1.2s linear infinite;
`;

const EllipticalLoader = () => {
  return (
    <LazyLoaderWrapper className="lazyLoader__loader text-center">
      <Spinner />
    </LazyLoaderWrapper>
  );
};

export default EllipticalLoader;

const LazyLoaderWrapper = styled.div`
  background: ${({ theme }) => theme.bodyBg};
  height: 80vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
